import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuLayout from "./MenuLayout";
import "../styles/PaymentResultPage.css";

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { orderId, paymentId } = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      orderId: params.get("order_id") || params.get("order"),
      paymentId: params.get("payment_id") || params.get("payment"),
    };
  }, [location.search]);

  const metaRows = [
    orderId && { label: "کد سفارش", value: orderId },
    paymentId && { label: "شناسه پرداخت", value: paymentId },
  ].filter(Boolean);

  return (
    <MenuLayout>
      <div className="payment-page">
        <header className="payment-header">
          <span className="payment-badge success">پرداخت موفق</span>
          <h1 className="payment-title">پرداخت شما با موفقیت انجام شد</h1>
          <p className="payment-subtitle">
            سفارش شما ثبت شده و در حال پردازش است. در صورت پرداخت با رمز ارز، تایید شبکه ممکن است چند دقیقه زمان ببرد.
          </p>
        </header>

        <div className="payment-card success">
          <div className="payment-content">
            <h2 className="payment-content-title">جزئیات پرداخت</h2>
            <p className="payment-note">
              می‌توانید وضعیت سفارش را در بخش سفارش‌ها مشاهده کنید. در صورت نیاز، تیم پشتیبانی در کنار شماست.
            </p>

            {metaRows.length > 0 && (
              <div className="payment-meta">
                {metaRows.map((row) => (
                  <div className="payment-meta-row" key={row.label}>
                    <span className="payment-meta-label">{row.label}</span>
                    <span className="payment-meta-value">{row.value}</span>
                  </div>
                ))}
              </div>
            )}

            <div className="payment-actions">
              <button className="payment-btn primary" onClick={() => navigate("/orders")}>
                مشاهده سفارش‌ها
              </button>
              <button className="payment-btn ghost" onClick={() => navigate("/dashboard")}>
                بازگشت به داشبورد
              </button>
            </div>
          </div>

          <div className="payment-visual">
            <img src="/images/ok.png" alt="پرداخت موفق" />
          </div>
        </div>
      </div>
    </MenuLayout>
  );
};

export default PaymentSuccessPage;
